import { AddressDTO } from "../DTO/addressDTO";

export class Address{

    public id? : number;
    public type? : number;
    public streetAddress1? : string;
    public streetAddress2? : string;
    public city? : string;
    public state? : string;
    public zipCode? : string;
    public country? : string;

    constructor(){
        this.type=0;
    }

    get formattedAddress():string{
        return this.streetAddress1 + ', ' + ((this.streetAddress2?.length)?(this.streetAddress2 +', '):'') + this.city + ', ' + this.state + ' ' + this.zipCode;
    }

    public static mapFromDTO(param:AddressDTO):Address{ 
        if (!param) throw new Error("parameter is null")
        let obj = new Address();
        try
        {
            obj.id = param.id;
            obj.type = param.type;
            obj.streetAddress1 = param.streetAddress1;
            obj.streetAddress2 = param.streetAddress2;
            obj.city = param.city;
            obj.state = param.state;
            obj.zipCode = param.zipCode;
            obj.country = param.country;
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    public static mapToDTO(param:Address):AddressDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new AddressDTO();
        try
        {
            dto.id = param.id;
            dto.type = param.type;
            dto.streetAddress1 = param.streetAddress1;
            dto.streetAddress2 = param.streetAddress2;
            dto.city = param.city;
            dto.state = param.state;
            dto.zipCode = param.zipCode;
            dto.country = param.country;
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }


}